import "./Header.scss"
import { LuxIcon, Color, useWindowResize } from "@lux/wardrobe-lib"
import { ReactChild } from "react"

const Header = (props: {
    children?: any
    negative?: boolean
    onBack?: () => void
    backIcon?: string
    onClose: () => void
    isFullScreen?: boolean
    onFullScreen?: () => void
    mobileLabel?: string
}) => {
    const {
        children,
        onBack,
        onClose,
        onFullScreen,
        isFullScreen,
        negative,
        backIcon,
        mobileLabel,
    } = props

    const isMobile = useWindowResize()

    const componentClass = `smart-modals-header`

    return (
        <div className={`${componentClass} ${negative ? "white-bg" : ""}`}>
            {onBack && (
                <div
                    className={`${componentClass}__back`}
                    onClick={onBack}
                    role={"button"}
                    tabIndex={0}>
                    <LuxIcon
                        icon={backIcon ? backIcon : "caret-left"}
                        color={isMobile || negative ? Color.BLACK : Color.WHITE}
                    />
                </div>
            )}
            <div className={`${componentClass}__breadcrumb ${negative ? "black-text" : ""}`}>
                {(!isMobile || !mobileLabel) && children}
                {isMobile && mobileLabel && <h1>{mobileLabel}</h1>}
            </div>
            <div className={`${componentClass}__icons`}>
                {!isMobile && onFullScreen && (
                    <div
                        className={`${componentClass}__fullScreen`}
                        onClick={onFullScreen}
                        role={"button"}
                        tabIndex={0}>
                        <LuxIcon
                            icon={isFullScreen ? "collapse" : "expand"}
                            color={isMobile || negative ? Color.BLACK : Color.WHITE}
                        />
                    </div>
                )}
                <div
                    className={`${componentClass}__close`}
                    onClick={onClose}
                    role={"button"}
                    tabIndex={0}>
                    <LuxIcon
                        icon="times"
                        color={isMobile || negative ? Color.BLACK : Color.WHITE}
                    />
                </div>
            </div>
        </div>
    )
}

export default Header
